// SearchSection.js - Modified to work with unified panel state

import { Data, DataSearch, Keyboard, List, Select, Toolbar, Box } from "grommet";
import React, { useState, useEffect, useRef } from "react";
import { getSuggestedAddress, getParsedAddress } from "../api";
import { PROPERTY_TYPES } from '../constants';
import { useAuth } from "../context";

const defaultOptions = PROPERTY_TYPES;
const SearchSection = ({
    propertyTypeSelected,
    setPropertyTypeSelected,
    addressSelected,
    setAddressSelected,
    gnafSelected,
    setGnafSelected,
    setAddressParsed,
    clearReport,
    isMobile,
    panels // Changed from inputValues to panels
}) => {
    const [addressInput, setAddressInput] = useState('');
    const [suggestedAddresses, setSuggestedAddresses] = useState([]);
    const [addressSearchPlaceholder, setAddressSearchPlaceholder] = useState('Search Address...');
    const [selected, setSelected] = useState();
    const [options, setOptions] = useState(defaultOptions);
    const hasFetchedRef = useRef(false);
    const { tokens } = useAuth();
    useEffect(() => {
        //console.log(addressInput)

        // clear page if new input
        // if (addressInput.length > 0) {
        //     setAddressSearchPlaceholder('Search Address...');
        //     clearReport();
        // }

        // get address suggestion
        if (addressInput.length && addressInput.length >= 3 && !hasFetchedRef.current) {
            hasFetchedRef.current = true;
            document?.getElementById("suggestedAddressSelect")?.setAttribute("style", "z-index:2");
            const getAddresses = async () => {
                const addresses = await getSuggestedAddress(tokens?.idToken, addressInput);
                setSuggestedAddresses(addresses);

            };
            getAddresses();
            hasFetchedRef.current = false;
        }
        else {
            setSuggestedAddresses([]);
        }

    }, [addressInput]);

    // get parsed address
    // useEffect(() => {
    //     if (gnafSelected.length > 0 && !hasFetchedRef.current) {
    //         const parseAddress = async () => {
                
    //             const parsed = await getParsedAddress(gnafSelected);
    //             setAddressParsed(parsed);
    //         };
    //         parseAddress();
            
    //     };
    //     console.log(gnafSelected)
    // }, [gnafSelected]);

    return (
        <Data data={suggestedAddresses} zIndex={3} >
            <Toolbar width={isMobile ? '100vw' : '53rem'}>
                <Box style={{
                    ...(isMobile ? { flex: '1 1 100%' } : {})
                }}>
                    <Keyboard
                        onDown={() => {
                            document?.getElementById('suggestedAddressSelect').focus()
                        }
                        }>
                        <DataSearch
                            width={isMobile ? '100vm' : "30rem"}
                            alignSelf="center"
                            id="addressInput"
                            placeholder={addressSearchPlaceholder}
                            value={addressInput} onChange={(event) => {
                                setAddressInput(event.target.value);
                            }}
                        />
                    </Keyboard>
                    <List
                        width={isMobile ? '100vm' : "30rem"}
                        defaultItemProps={{ zIndex: 3 }}
                        zIndex={2}
                        id='suggestedAddressSelect'
                        border={true}
                        onClickItem={
                            (event) => {
                                if (event?.item?.address) {
                                    const newGnaf = event.item.id; // GNAF of the selected address

                                    // Check if any existing panel has the same GNAF
                                    const gnafExists = panels.some(panel =>
                                        panel.values && panel.values.gnaf === newGnaf
                                    );

                                    if (gnafExists) {
                                        window.alert("The security has already been added.");
                                    } else {
                                        if (event.item.id !== gnafSelected) {
                                            setAddressSearchPlaceholder('Search Address...');
                                            clearReport();
                                        }
                                        setGnafSelected(event.item.id);
                                        setSelected(selected === event.index ? undefined : event.index);
                                        setAddressSelected(event.item.address);
                                        setAddressSearchPlaceholder(event.item.address);
                                        setAddressInput('');
                                        //document?.getElementById('propertyTypeSelect').click();
                                        if (newGnaf.length > 0) {
                                            const parseAddress = async () => {
                                                
                                                const parsed = await getParsedAddress(tokens?.idToken, newGnaf);
                                                setAddressParsed(parsed);
                                            };
                                            parseAddress();
                                            
                                        };
                                    }
                                }
                            }
                        }
                    />
                </Box>
                <Box style={{
                    ...(isMobile ? { flex: '1 1 100%' } : {})
                }}>
                    <Select
                        id='propertyTypeSelect'
                        disabled={addressSelected?.length <= 0 || defaultOptions.filter((o) => o.index ?? !o.keywords)}
                        options={options}
                        placeholder={'Select Property Type...'}
                        value={propertyTypeSelected}
                        onChange={(event) => {
                            //console.log(event.value?.label);
                            setPropertyTypeSelected(event.value?.label);
                            hasFetchedRef.current = false;
                        }}
                        onSearch={(text) => {
                            // The line below escapes regular expression special characters:
                            // [ \ ^ $ . | ? * + ( )
                            const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');

                            // Create the regular expression with modified value which
                            // handles escaping special characters. Without escaping special
                            // characters, errors will appear in the console
                            const exp = new RegExp(escapedText, 'i');
                            setOptions(defaultOptions.filter((o) => exp.test(o.keywords)));
                        }}
                        onClose={() => setOptions(defaultOptions)}
                        itemProp=""
                    />
                </Box>
            </Toolbar>
        </Data>
    )
};

export { SearchSection }